// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1WqE1","range":"MonthRangeSwitch_range__2lGmu","disabled":"MonthRangeSwitch_disabled__yRsaR"};